import { useState } from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import { copyToClipboard } from '../../utils/functions';
import IconCopy from '../svg/IconCopy';
import IconArrow from '../svg/IconArrow';

const AccountButton = ({ data }) => {
  const [isActive, setActive] = useState(false);
  return (
    <>
      <StyledButton
        type="button"
        className={clsx({ active: isActive })}
        onClick={() => setActive(!isActive)}
      >
        {data.name}
        <IconArrow />
      </StyledButton>
      {isActive && (
        <ul>
          {data.accounts.map((account) => (
            <StyledLi key={account.id}>
              <p>
                <StyledSpan className={account.id == 1 && 'space'}>
                  {account.role}
                </StyledSpan>
                {account.name}
              </p>
              <StyledAccountP>
                {account.account[0]} | {account.account[1]}
              </StyledAccountP>
              <StyledCopyButton
                type="button"
                onClick={() => copyToClipboard(account.account[1])}
              >
                <IconCopy />
                <span className="a11y-hidden">계좌번호 복사하기</span>
              </StyledCopyButton>
            </StyledLi>
          ))}
        </ul>
      )}
    </>
  );
};

const StyledButton = styled.button`
  display: flex;
  justify-content: space-between;
  width: 33rem;
  padding: 2rem 4rem;
  background-color: var(--background);
  box-sizing: border-box;
  border-radius: 1.6rem;
  border: 1px solid var(--grayLv2);
  color: var(--surface);

  &:hover path {
    fill: var(--surface);
  }

  &.active {
    border-radius: 1.6rem 1.6rem 0 0;

    path {
      fill: var(--surface);
    }

    svg {
      transform: rotate(180deg);
    }
  }
`;

const StyledLi = styled.li`
  position: relative;
  width: 100%;
  padding: 1rem 4rem;
  box-sizing: border-box;
  background: var(--background);
  border: 1px solid var(--grayLv2);
  border-top: none;

  &:last-of-type {
    border-radius: 0 0 1.6rem 1.6rem;
  }
`;

const StyledCopyButton = styled.button`
  position: absolute;
  top: 50%;
  right: 4rem;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;

  & > svg {
    width: 100%;
    height: 100%;
    object-fit: cover;

    &:hover path {
      fill: var(--grayLv4);
    }
  }
`;

const StyledSpan = styled.span`
  color: var(--primary);
  margin-right: 1rem;

  &.space {
    letter-spacing: 1.4rem;
    margin-right: -0.4rem;
  }
`;

const StyledAccountP = styled.p`
  margin-top: 0.5rem;
  color: var(--grayLv3);
`;

export default AccountButton;
